function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: o-HelveticaNeue, Arial, sans-serif;\n  font-weight: 700;\n  color: ", ";\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :hover,\n  :focus {\n    text-decoration-color: ", ";\n  }\n\n  :active {\n    color: ", ";\n  }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../styles/variables';
var StyledLink = styled('a')(_templateObject(), function (_ref) {
  var color = _ref.color,
      disabled = _ref.disabled;

  switch (color) {
    case 'white':
      return !disabled ? colors.white : colors.grey3;

    default:
      return !disabled ? colors.black : colors.grey4;
  }
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled ? 'pointer' : 'default';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'none' : undefined;
}, function (_ref4) {
  var color = _ref4.color;

  switch (color) {
    case 'white':
      return colors.primary;

    default:
      return colors.primaryDark;
  }
}, function (_ref5) {
  var color = _ref5.color;

  switch (color) {
    case 'white':
      return colors.primary;

    default:
      return colors.primaryDark;
  }
});

function Link(props) {
  var children = props.children,
      disabled = props.disabled,
      rest = _objectWithoutPropertiesLoose(props, ["children", "disabled"]);

  return React.createElement(StyledLink, _extends({
    disabled: disabled,
    tabIndex: disabled ? -1 : undefined
  }, rest), children);
}

Link.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['black', 'white']),
  disabled: PropTypes.bool
} : {};
Link.defaultProps = {
  color: 'black',
  disabled: false
};
export default Link;